///<reference path="../token-list/token-list.routing.ts"/>
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgxPaginationModule} from 'ngx-pagination';
import {AutoCompleteModule, MultiSelectModule} from 'primeng/primeng';

import {ChangeLanguageModule} from '../shared/change-language/change-language.module';
import {LayoutModule} from '../layout/layout.module';
import {SharedTranslationModule} from '../shared/change-language/shared-translation.module';
import {HttpModule} from '@angular/http';
import {routing} from './token-display.routing';
import {TokenDisplayComponent} from './token-display.component';
import {GenerateTokenService} from '../opd/generate-token/generate-token.service';

@NgModule({
  imports: [
    CommonModule,
      routing,
      FormsModule,
      HttpModule,
      ReactiveFormsModule, SharedTranslationModule, ChangeLanguageModule,
      NgxPaginationModule, LayoutModule,
      AutoCompleteModule, MultiSelectModule
  ],
  declarations: [TokenDisplayComponent],
    providers: [GenerateTokenService]
})
export class TokenDisplayModule { }



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/token-display/token-display.module.ts